import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@/shared/components/input/Checkbox';
import intlShape from '@/shared/utils/intlShape';
import { StateService } from '@/shared/services/StateService';
import messages from './trainingMessages';
import FormattedListValue, { listItemMsg } from '@/shared/components/FormattedListValue';
import { FaRegClock, FaSearch } from 'react-icons/fa';

const TrainingEmployeeOverviewRow = ({
  training,
  intl,
  handleSelect,
  onAddRegistrationClick,
  onOpenEmployeeTrainingDetailsClick,
}) => {
  return (
    <tbody className="hover" key={training.Id} id={`RowID${training.Id}`}>
      <tr>
        <td>
          <Checkbox onClick={() => handleSelect(training)} value={training.selected} />
        </td>
        <td>
          <a
            title={intl.formatMessage(messages.OpenTrainingDetails)}
            onClick={() => {
              onOpenEmployeeTrainingDetailsClick(training);
            }}
          >
            <b>{training.trainingName}</b>
          </a>
        </td>
        <td>
          <FormattedListValue list="trainingStatus" id={training.trainingEmployeeStatus} />
        </td>
        <td>
          <FormattedListValue list="trainingType" id={training.type} />
        </td>
        <td>
          <i
            className={`fa ${training.mandatory ? 'fa-check text-success' : 'fa-times text-muted'}`}
          />
        </td>
        <td>{training.trainingDurationHours}</td>
        <td>{training.trainingEmployeeDurationMinutes.minuteToTime()}</td>
        <td>{intl.formatDate(training.trainingStartDate)}</td>
        <td>{intl.formatDate(training.trainingEndDate)}</td>
        <td>{training.completedDate ? intl.formatDate(training.completedDate) : ''}</td>
        <td className="text-right">
          {training.trainingEmployeeStatus !== 3 && (
            <a
              className="btn btn-xs btn-icon margin5R"
              title={intl.formatMessage(messages.AddRegistration)}
              onClick={() => {
                onAddRegistrationClick(training);
              }}
            >
              <FaRegClock />
            </a>
          )}
          <a
            className="btn btn-xs btn-icon margin5R"
            title={intl.formatMessage(messages.OpenTrainingDetails)}
            onClick={() => {
              onOpenEmployeeTrainingDetailsClick(training);
            }}
          >
            <FaSearch />
          </a>
        </td>
      </tr>
    </tbody>
  );
};

TrainingEmployeeOverviewRow.propTypes = {
  intl: intlShape.isRequired,
  training: PropTypes.object.isRequired,
  handleSelect: PropTypes.func.isRequired,
  stateService: PropTypes.instanceOf(StateService).isRequired,
  onAddRegistrationClick: PropTypes.func,
  onOpenEmployeeTrainingDetailsClick: PropTypes.func,
};

export default TrainingEmployeeOverviewRow;
